export const SVG_NAMES: any = {
  // action
  ADD: "Add",
  ARROWDOWN: "ArrowDown",
  ARROWLEFT: "ArrowLeft",
  ARROWRIGHT: "ArrowRight",
  ARROWSOLIDDOWN: "ArrowSolidDown",
  ARROWSOLIDLEFT: "ArrowSolidLeft",
  ARROWSOLIDRIGHT: "ArrowSolidRight",
  ARROWSOLIDUP: "ArrowSolidUp",
  ARROWUP: "ArrowUp",
  CARETDOWN: "CaretDown",
  CARETDUODOWN: "CaretDuoDown",
  CARETDUOLEFT: "CaretDuoLeft",
  CARETDUORIGHT: "CaretDuoRight",
  CARETDUOUP: "CaretDuoUp",
  CARETLEFT: "CaretLeft",
  CARETRIGHT: "CaretRight",
  CARETUP: "CaretUp",
  CHECK: "Check",
  CHECKBOXCHECKED: "CheckboxChecked",
  CHECKBOXDEFAULT: "CheckboxDefault",
  CHECKBOXSEMI: "CheckboxSemi",
  CIRCLEADD: "CircleAdd",
  CIRCLEDOWN: "CircleDown",
  CIRCLELEFT: "CircleLeft",
  CIRCLEREMOVE: "CircleRemove",
  CIRCLERIGHT: "CircleRight",
  CIRCLEUP: "CircleUp",
  CLOSE: "Close",
  COLLAPSE: "Collapse",
  DOWNLOAD: "Download",
  DUPLICATE: "Duplicate",
  EDIT: "Edit",
  EDITHIDE: "EditHide",
  EDITSHOW: "EditShow",
  EXIT: "Exit",
  EXPAND: "Expand",
  FAVORITEFILLED: "FavoriteFilled",
  FAVORITEOUTLINE: "FavoriteOutline",
  FILTER: "Filter",
  FILTER2: "Filter2",
  FILTERALT: "FilterAlt",
  HAND: "Hand",
  HOME: "Home",
  LOCK: "Lock",
  LOCKOPEN: "LockOpen",
  MENUHAMBURGUER: "MenuHamburguer",
  MENUKEBAB: "MenuKebab",
  MENUMEATBALL: "MenuMeatball",
  NEWTAB: "NewTab",
  RADIOBUTTONCHECKED: "RadioButtonChecked",
  RADIOBUTTONUNCHECKED: "RadioButtonUnchecked",
  REFRESH: "Refresh",
  REMOVE: "Remove",
  SEARCH: "Search",
  SETTING: "Setting",
  SHARE: "Share",
  SORT: "Sort",
  STARHALF: "StarHalf",
  STAROUTLINE: "StarOutline",
  START: "Start",
  THREED: "ThreeD",
  THREEDALT: "ThreeDAlt",
  TRASH: "Trash",
  STARCHECK: "StarCheck",
  // comm
  ACCOUNT: "Account",
  BOOKMARK: "Bookmark",
  CALENDAR: "Calendar",
  CALENDARADD: "CalendarAdd",
  CALENDARCHECK: "CalendarCheck",
  CALENDARCLOSE: "CalendarClose",
  CALENDAREDIT: "CalendarEdit",
  CALENDARREMOVE: "CalendarRemove",
  CHAT: "Chat",
  CHAT1: "Chat1",
  CHATFILLED: "ChatFilled",
  LABEL: "Label",
  LIST: "List",
  MAIL: "Mail",
  MAILOPEN: "MailOpen",
  PEOPLE: "People",
  PHONE: "Phone",
  SMILE: "Smile",
  TAG: "Tag",
  TEXTSMS: "Textsms",
  WIFI: "Wifi",
  WIFIOFF: "WifiOff",
  // data
  BARGRAPH: "BarGraph",
  CALCULATOR: "Calculator",
  CHARTDOWN: "ChartDown",
  CHARTUP: "ChartUp",
  DASHBOARD: "Dashboard",
  DATA: "Data",
  DOUGHNUTCHART: "DoughnutChart",
  GLOBE: "Globe",
  GRID: "Grid",
  LAYERS: "Layers",
  LINEDOWN: "LineDown",
  LINEUP: "LineUp",
  MONEYCIRCLE: "MoneyCircle",
  MONEY: "Money",
  PERCENT: "Percent",
  PIECHART: "PieChart",
  REPORTS: "Reports",
  SOP: "Sop",
  VIEWHORIZONTAL: "ViewHorizontal",
  VIEWTABLEHORIZONTAL: "ViewTableHorizontal",
  VIEWTABLEVERTICAL: "ViewTableVertical",
  VIEWVERTICAL: "ViewVertical",
  // tracker
  EXCEPTIONTRACKER: "ExceptionTracker",
  INPROGRESSTRACKER: "InProgressTracker",
  READYTRACKER: "ReadyTracker",
  RECEIVEDTRACKER: "ReceivedTracker",
  SUBMITTEDTRACKER: "SubmittedTracker",
  // file
  ATTACHMENT: "Attachment",
  CLOUDDONE: "CloudDone",
  CLOUDOFF: "CloudOff",
  CLOUDUPLOAD: "CloudUpload",
  CLOUD: "Cloud",
  CONTENTCHECK: "ContentCheck",
  CONTENTFAVORITE: "ContentFavorite",
  CONTENT: "Content",
  FILEADD: "FileAdd",
  FILEFIND: "FileFind",
  FILEREMOVE: "FileRemove",
  FILEUPLOAD: "FileUpload",
  FOLDERADD: "FolderAdd",
  FOLDEROPEN: "FolderOpen",
  FOLDERREMOVE: "FolderRemove",
  FOLDERUPLOAD: "FolderUpload",
  FOLDER: "Folder",
  INVENTORY: "Inventory",
  REPORT: "Report",
  UNLINK: "Unlink",
  // map
  MAPVIEW: "Mapview",
  MYLOCATION: "MyLocation",
  NAVIGATION: "Navigation",
  NEARME: "NearMe",
  NEARMEDISABLED: "NearMeDisabled",
  NORTH: "North",
  PINCIRCLE: "PinCircle",
  PINCIRCLEBORDER: "PinCircleBorder",
  PINSQUARE: "PinSquare",
  PINSQUAREBORDER: "PinSquareBorder",
  PLACE: "Place",
  PLACEADD: "PlaceAdd",
  PLACECHART: "PlaceChart",
  PLACECHECK: "PlaceCheck",
  // media
  CAMERA: "Camera",
  DEVICES: "Devices",
  LAPTOP: "Laptop",
  MIC: "Mic",
  MICNONE: "MicNone",
  MICOFF: "MicOff",
  MOBILE: "Mobile",
  MONITOR: "Monitor",
  PAUSE: "Pause",
  PLAY: "Play",
  SLOWMOTION: "SlowMotion",
  TABLET: "Tablet",
  VOLUMEDOWN: "VolumeDown",
  VOLUMEMUTE: "VolumeMute",
  VOLUMEOFF: "VolumeOff",
  VOLUMEUP: "VolumeUp",
  // notification
  BLOCK: "Block",
  CONTRAST: "Contrast",
  ERROR: "Error",
  ERRORFILLED: "ErrorFilled",
  INFORMATION: "Information",
  INFORMATIONFILLED: "InformationFilled",
  INPROGRESS: "InProgress",
  NOTIFICATION: "Notification",
  QUESTION: "Question",
  WARNING: "Warning",
  WARNINGFILLED: "WarningFilled",
  // place
  ACTIVECOMMUNITY: "ActiveCommunity",
  BANK: "Bank",
  BASKETBALL: "Basketball",
  BATHTUB: "Bathtub",
  BED: "Bed",
  BICYCLE: "Bicycle",
  FITNESS: "Fitness",
  FLOORS: "Floors",
  FLOORS1: "Floors1",
  GARAGE: "Garage",
  GATE: "Gate",
  HOUSE: "House",
  LAKE: "Lake",
  MEASURE: "Measure",
  OFFICE: "Office",
  PARK: "Park",
  PICNIC: "Picnic",
  POOL: "Pool",
  SOCCER: "Soccer",
  STUDIO: "Studio",
  TENNIS: "Tennis",
  VOLLEYBALL: "Volleyball",
  // status
  CIRCLECHECKFILLED: "CircleCheckFilled",
  CIRCLECHECK: "CircleCheck",
  CIRCLECLOSEFILLED: "CircleCloseFilled",
  CIRCLECLOSE: "CircleClose",
  SALESFORCE: "SalesForce",
};
